import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { ix } from '../../../../../../../../utils/ix';
import AddIcon from '@mui/icons-material/Add';
import { useStyles } from './AddFilterChip.styles';
import { cx } from '@emotion/css';
export const AddFilterChip = memo(({ id, className }) => {
    const classes = useStyles();
    return (React.createElement(Box, { id: ix(id, 'chip'), className: cx(classes.root, className) },
        React.createElement(AddIcon, { fontSize: "small" }),
        React.createElement("span", null, "Filters")));
});
//# sourceMappingURL=AddFilterChip.js.map